const { styled } = require("@mui/material");

export const StyledStatusBadge = styled("span")(({ theme, color }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  padding: "4px 10px",
  borderRadius: 20,
  fontWeight: 600,
  fontSize: 14,
  backgroundColor: `${color}22`, // 22 = transparence
  color,
  userSelect: "none",
  minWidth: 110,
  justifyContent: "center",
  boxShadow: `0 0 6px ${color}55`,
}));
